<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
#app {
  margin: 0;
  padding: 0;
  color: #535353;
  font-size: 14px;
  font-family: 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', 'ヒラギノゴシック', 'Hiragino Sans', 'メイリオ',
    Meiryo, Osaka, 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
  font-weight: 300;
  line-height: 1.5;
  main {
    max-width: 720px;
    margin: 0 auto;
    padding: 0 15px;
    @media (min-width: 576px) {
      padding: 0;
    }
  }
}
</style>
